import { $win, $doc, $body } from "../utils/globals";

$doc.on("click", function(e) {
	if (!e.target.closest(".nav")) {
		$(".nav")
			.find("li")
			.removeClass("is-hovered")
	}
});
